module.exports = __webpack_public_path__ + "img/about/80243-043.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-043.png
// module id = 41
// module chunks = 0